import {useState, useCallback, DragEvent} from 'react';


export type HandleFilesCb = (files: FileList) => void;


export function useDropArea(handleFiles: HandleFilesCb, allowedFileTypes: string[] = []) {
    const [isDragOver, setIsDragOver] = useState(false);

    const validateFileTypes = useCallback((items: DataTransferItemList): boolean => {
        if (!allowedFileTypes.length) {
            return true; // If no allowed file types are specified, accept all files
        }
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.kind !== 'file' || !allowedFileTypes.includes(item.type)) {
                return false;
            }
        }
        return true;
    }, [allowedFileTypes]);

    const onDragOver = useCallback((event: DragEvent) => {
        // required for onDrop to work
        event.preventDefault();
        event.stopPropagation();
    }, [])

    const onDragEnter = useCallback((event: DragEvent) => {
        const hasFiles = Array.from(event.dataTransfer.items).some(item => item.kind === 'file');
        if (hasFiles) {
            setIsDragOver(true);
        }
    }, []);

    const onDragLeave = useCallback((event: DragEvent) => {
        // relatedTarget - target device entered to
        // currentTarget - target event bound to
        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
            setIsDragOver(false);
        }
    }, []);

    const onDrop = useCallback((event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        if (validateFileTypes(event.dataTransfer.items)) {
            handleFiles(event.dataTransfer.files);
        }
        setIsDragOver(false);

    }, [handleFiles, allowedFileTypes, validateFileTypes]);

    return {
        isDragOver,
        onDragOver,
        onDragEnter,
        onDragLeave,
        onDrop,
    };
}
